import axios from 'axios';
import { refreshSession } from './refresh-session';

export const catchError = (error) => {
  if (error.response) {
    if (Array.isArray(error.response.data.message))
      throw new Error(error.response.data.message.join('\n'));
    else throw new Error(error.response.data.message);
  } else {
    throw new Error(error.message);
  }
};

const $api = axios.create();

$api.interceptors.response.use(null, async (error) => {
  const { config, response } = error;
  if (response?.status !== 401 || config.retried) return Promise.reject(error);

  const failedToken = config.headers?.['X-Auth-Token'];
  // kiosk-token requests carry no X-Auth-Token, so a kiosk 401 never refreshes or signs out
  if (!failedToken) return Promise.reject(error);

  const token = await refreshSession(failedToken).catch(() => Promise.reject(error));
  return $api.request({ ...config, retried: true, headers: { ...config.headers, 'X-Auth-Token': token } });
});

export default $api;
